export default {
  props: {
    receivedUnidade: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.unidade = this.receivedUnidade
  },

  data: () => ({
    unidade: {},
    dialogKey: false,
  }),

  methods: {
    close() {
      this.dialogKey = !this.dialogKey
    },
  },
}
